import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';
import linkifyStr from 'linkifyjs/string';

@Pipe({
  name: 'corrigirLinks',
})
export class CorrigirLinksPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
  transform(value: string) {
    return value ? linkifyStr(value, {target: '_blank'}): value;
    /*const r = /([--:\w?@%&+~#=]*\.[a-z]{2,4}\/{0,2})((?:[?&](?:\w+)=(?:\w+))+|[--:\w?@%&+~#=]+)?/g
    const matches = value.match(r)
    if (matches) {
      const uniq = [...new Set(matches)];
      for (const u of uniq) {
        const escapedRegExp = this.escapeRegExp(u);
        value = value.replace(new RegExp(escapedRegExp, 'g'), `<a href="${u}" onclick="event.stopPropagation()" target="_blank">${u}</a>`);
      }
      return this.sanitized.bypassSecurityTrustHtml(value);
    }
    return value;*/
  }

  private escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  }
}



// WEBPACK FOOTER //
// ./src/pipes/corrigir-links/corrigir-links.ts